// ----------------------------------------------------------------------

export default function Autocomplete(theme) {
  return {
    MuiAutocomplete: {

      styleOverrides: {
        inputRoot: {
          height: 30,
          background: 'white'
        },
        groupLabel:{
          color: theme.palette.text.primary,
          borderBottom: `1px solid ${theme.palette.divider}`,

        },
        paper: {
          boxShadow: theme.customShadows.dropdown
        },
        endAdornment: {
          lineHeight: '27px'
        },
        clearIndicator: {
          color: theme.palette.primary.main,
        },
        popupIndicator: {
          color: theme.palette.primary.main
        },
        listbox: {
          padding: theme.spacing(0),
          '& .MuiAutocomplete-option': {
            fontSize: 'small',
            padding: theme.spacing(1),
            margin: theme.spacing(0, 0, 0, 0.1),
            borderRadius: 0,
            borderBottom: `1px solid ${theme.palette.divider}`

          },

          "&  .MuiAutocomplete-option[aria-selected='true']":
          {
            borderLeft: 'solid', borderLeftWidth: 5, borderLeftColor: theme.palette.primary.main
          },

        }
      }
    }
  };
}
